export default __webpack_public_path__ + "media/images/ico-message-a9ba02d239ed202db7996f032dbb7442.svg";